import { useEffect } from 'react'
import { assetUrl } from './assetUrl'

/**
 * Foile de stil ale UNEI pagini (in machete: `<link>` scris in view, cu
 * `?v=RELEASE_VERSION`). Se pun in <head> cand pagina se deschide si se scot
 * cand se inchide, ca regulile lor sa nu ajunga pe alte ecrane.
 *
 * Caile se dau relativ la `public/` al aplicatiei (`css/adm.css`); prefixul
 * `base` il pune `assetUrl()` - foile nu se mai iau de la portalul vechi.
 */
export function usePageStyles(hrefs: string[], version: string): void {
  const key = hrefs.join('|')
  useEffect(() => {
    const links = hrefs.map((href) => {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = `${assetUrl(href)}?v=${version || '0'}`
      link.dataset.page = 'v4'
      document.head.appendChild(link)
      return link
    })
    return () => links.forEach((l) => l.remove())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, version])
}
